import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import ReduxThunk from 'redux-thunk';

import Reducers from './redux-store';

import App from './ui/app';

import 'semantic-ui-css/semantic.min.css';
import './ui/assets/scss/variables.scss';
import './ui/assets/scss/fonts.scss';
import './ui/assets/scss/generic.scss';
import './ui/assets/scss/helpers.scss';
import './ui/assets/scss/buttons.scss';
import './ui/assets/scss/inputs.scss';
import 'react-querybuilder/dist/query-builder.css';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    Reducers,
    composeEnhancers(applyMiddleware(ReduxThunk))
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Provider store={store}>
    <App />
</Provider>);